// Key Accounts Daily feed configs, through the `dashoneKeyAccountsDailyConfig`
// Firebase function. The function needs a Dashmote admin and validates every
// draft with the same validator the Daily page loads the config with.
import { callAdminFunction } from "../features/dashai/lib/firebaseAdminClient";

const FN = "dashoneKeyAccountsDailyConfig";

/** Every feed: `{ workspace, country, enabled, brand, platform, version }[]`. */
export const listDailyFeeds = () =>
  callAdminFunction(FN, { op: "list" }).then((r) => r.feeds);

/** One feed's `{ config, version }`. */
export const getDailyFeed = (workspace, country) =>
  callAdminFunction(FN, { op: "get", workspace, country });

/** `{ ok, error?, rebuildsDays }` for a draft, without saving it. */
export const checkDailyFeed = (workspace, country, config) =>
  callAdminFunction(FN, { op: "check", workspace, country, config });

/** Saves a draft over `version` (null creates the feed) and answers `{ version, rebuildsDays }`. */
export const saveDailyFeed = (workspace, country, config, version) =>
  callAdminFunction(FN, { op: "save", workspace, country, config, version });

/** The versions saves replaced, latest first: `{ id, replacedAt, replacedBy, config }[]`. */
export const dailyFeedHistory = (workspace, country) =>
  callAdminFunction(FN, { op: "history", workspace, country }).then(
    (r) => r.entries,
  );
